module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "has-text-left"
  }, [_c('div', {
    staticClass: "field"
  }, [(_vm.APM) ? _c(_vm.methods[_vm.APM], {
    tag: "component",
    on: {
      "request": _vm.sendMulixWDRequest
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ccd4f926"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finance/withdraw-methods/Mulix.vue
// module id = 808
// module chunks = 0